import axiosInstance from './axiosInstance';
import { legacyApiInstance } from './axiosInstance';
import store from '../store';

export const fetchAuctionCompaniesAPI = async (email: string) => {
    const response = await axiosInstance.get(`/Auth/GetTenants`, {
        params: {
            username: email,
        },
    });
    // console.log("response", response)
    return response.data.map((tenant: { tenantKey: string; tenantName: string }) => ({
        value: tenant.tenantKey,
        label: tenant.tenantName,
    }));
};

export const loginUserAPI = async (email: string, password: string, auctionCompany: string) => {
    const response = await axiosInstance.post(`/Auth/Login`, {
        User_Name: email,
        Password: password,
        Tenant: auctionCompany,
    });
    return {token: response.data.token, refreshToken: response.data.refresh_token, userName: response.data.userName, userId: response.data.user_ID};
};

export const getRefreshTokenAPI = async (RefreshToken: string, Tenant: string) => {
    const response = await axiosInstance.post(`/Auth/Refresh`, {
        RefreshToken,
        Tenant
    });
    return {token: response.data.token, refreshToken: response.data.refresh_token};
};

export const getFeatureFlagsAPI = async () => {
    const state = store.getState();
    const { token, tenant, userId } = state.auth;
    
    if (!token || !tenant) {
        throw new Error('Authentication required for feature flags');
    }
    
    const response = await legacyApiInstance.get(`/FeatureFlags/GetAll?User_ID=${userId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Tenant: tenant,
        },
    });
    return response;
};
